var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 85,
    viewBox: "0 0 85 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 11374"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 11372"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M42 80C62.4345 80 79 63.4345 79 43C79 22.5655 62.4345 6 42 6C21.5655 6 5 22.5655 5 43C5 63.4345 21.5655 80 42 80Z",
    fill: "#2B2A28"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M55.1034 31.6641L54.5104 32.2571L54.4738 32.2937C54.1444 32.6305 53.6905 32.8355 53.1853 32.8355C52.3288 32.8355 51.6113 32.2425 51.421 31.4445C51.4137 31.3786 51.399 31.3127 51.3844 31.2541C51.3844 31.2395 51.3844 31.2249 51.3844 31.2029C50.5351 26.7152 46.6111 23.4134 41.9623 23.4134C36.6766 23.4134 32.3646 27.7181 32.3646 33.0112V44.3659L41.9623 47.0747V50.845L28.7334 47.1113V33.0185C28.7334 25.7268 34.6634 19.7969 41.955 19.7969C45.2714 19.7969 48.4487 21.0341 50.8939 23.2816C52.2336 24.5189 53.2951 25.9904 54.0272 27.6156C54.4518 28.5674 54.7666 29.5703 54.957 30.6099C54.9716 30.6831 54.979 30.7417 54.9936 30.8149C54.9936 30.8222 54.9936 30.8368 54.9936 30.8442C55.0448 31.1224 55.0814 31.4006 55.1034 31.6788V31.6641Z",
    fill: "#D4F3EF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M55.0018 31.0192C55.0018 31.5024 54.8188 31.9343 54.5113 32.2638L54.4747 32.3004C54.1452 32.6371 53.6913 32.8421 53.1862 32.8421C52.3297 32.8421 51.6122 32.2491 51.4219 31.4511C51.4145 31.3853 51.3999 31.3194 51.3853 31.2608C51.3853 31.2462 51.3853 31.2315 51.3853 31.2096C51.3853 31.151 51.3779 31.0851 51.3779 31.0265C51.3779 30.5214 51.5829 30.0675 51.9124 29.738C52.2418 29.4086 52.6957 29.2109 53.1935 29.2109C54.0501 29.2109 54.7748 29.8039 54.9652 30.6092C54.9798 30.6824 54.9872 30.741 55.0018 30.8142C55.0018 30.8215 55.0018 30.8362 55.0018 30.8435C55.0018 30.9021 55.0091 30.968 55.0091 31.0265L55.0018 31.0192Z",
    fill: "#D4F3EF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M59.4522 27.3196L54.5105 32.2613L54.4739 32.2906L51.9043 29.7282L54.0274 27.6052L56.8825 24.75L59.4522 27.3196Z",
    fill: "#D4F3EF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M28.8934 54.3449L29.4864 53.7519L29.523 53.7153C29.8524 53.3785 30.3063 53.1736 30.8114 53.1736C31.668 53.1736 32.3854 53.7666 32.5758 54.5645C32.5831 54.6304 32.5978 54.6963 32.6124 54.7549C32.6124 54.7695 32.6124 54.7842 32.6124 54.8061C33.4616 59.2939 37.3856 62.5956 42.0344 62.5956C47.3201 62.5956 51.6322 58.2909 51.6322 52.9979V41.6431L42.0344 38.9343V35.1641L55.2634 38.8977V52.9905C55.2634 60.2822 49.3334 66.2121 42.0418 66.2121C38.7254 66.2121 35.5481 64.9749 33.1029 62.7274C31.7632 61.4901 30.7016 60.0186 29.9695 58.3934C29.5449 57.4417 29.2301 56.4387 29.0398 55.3991C29.0251 55.3259 29.0178 55.2674 29.0032 55.1941C29.0032 55.1868 29.0032 55.1722 29.0032 55.1649C28.9519 54.8867 28.9153 54.6085 28.8934 54.3303V54.3449Z",
    fill: "#75D9D0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M28.9976 54.9948C28.9976 54.5116 29.1806 54.0797 29.4881 53.7502L29.5247 53.7136C29.8541 53.3769 30.308 53.1719 30.8131 53.1719C31.6697 53.1719 32.3871 53.7649 32.5775 54.5629C32.5848 54.6287 32.5995 54.6946 32.6141 54.7532C32.6141 54.7678 32.6141 54.7825 32.6141 54.8044C32.6141 54.863 32.6214 54.9289 32.6214 54.9875C32.6214 55.4926 32.4164 55.9465 32.087 56.276C31.7575 56.6054 31.3036 56.8031 30.8058 56.8031C29.9493 56.8031 29.2245 56.2101 29.0342 55.4048C29.0195 55.3316 29.0122 55.273 28.9976 55.1998C28.9976 55.1925 28.9976 55.1778 28.9976 55.1705C28.9976 55.1119 28.9902 55.046 28.9902 54.9875L28.9976 54.9948Z",
    fill: "#75D9D0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M24.5459 58.6897L29.4875 53.748L29.5241 53.7188L32.0938 56.2811L29.9707 58.4041L27.1155 61.2593L24.5459 58.6897Z",
    fill: "#75D9D0"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSell);
export default __webpack_public_path__ + "static/media/iconSell.0f4095a037e9def01b65fd456b0c4400.svg";
export { ForwardRef as ReactComponent };